import { UserInfoDto } from "./ApiClient";

const USER_KEY = "bearcms_user" as string;

/**
 * @description get user form localStorage
 */
export const getUser = (): UserInfoDto | null => {
    var u = window.localStorage.getItem(USER_KEY);
    if (u) {
        return UserInfoDto.fromJS(JSON.parse(u));
    };
    return null;
};

/**
 * @description save user into localStorage
 * @param user: string
 */
export const saveUser = (user: UserInfoDto): void => {
    window.localStorage.setItem(USER_KEY, JSON.stringify(user));
};

/**
 * @description remove user form localStorage
 */
export const destroyUser = (): void => {
    window.localStorage.removeItem(USER_KEY);
};

export default { saveUser, getUser, destroyUser };
